import React from 'react';
import styled from 'styled-components';

import { Navigate } from '@shared/enums/navigate';

type NavItemProps = {
  href: string;
  title?: Navigate;
  onLinkClick: (e: React.MouseEvent<HTMLElement>) => void;
};

function NavItem({ onLinkClick, title, href }: NavItemProps) {
  const toUpperCase = (title: string) => {
    return `${title.slice(0, 1).toUpperCase()}${title.slice(1, title.length)}`;
  };

  return (
    <StyledLi onClick={onLinkClick}>
      <StyledLink href={href}>{toUpperCase(title!)}</StyledLink>
    </StyledLi>
  );
}

const StyledLink = styled.a`
  font-size: 18px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const StyledLi = styled.li`
  margin: 10px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  cursor: pointer;
`;

export default NavItem;
